import React from "react";
import { Box } from "native-base";
import Input from "../../../../../components/Input";
import InputCustom from "../../../../../components/InputCustom";
import InputMask from "../../../../../components/InputCustom";
import { useTheme } from "../../../../../ThemeProvider";

interface DadosBasicosProps {
  getConfigEmpresa: any;
  nome: string;
  setNome: (value: string) => void;
  telefone: string;
  setTelefone: (value: string) => void;
  email: string;
  setEmail: (value: string) => void;
  cpf: string;
  setCpf: (value: string) => void;
  dataNascimento: string;
  setDataNascimento: (value: string) => void;
  dadosImportados?: boolean;
}

const DadosBasicos: React.FC<DadosBasicosProps> = ({
  getConfigEmpresa,
  nome,
  setNome,
  telefone,
  setTelefone,
  email,
  setEmail,
  cpf,
  setCpf,
  dataNascimento,
  setDataNascimento,
  dadosImportados,
}) => {
  const { primaryColor } = useTheme();
  const corFoco = primaryColor || undefined;

  return (
    <>
      <Box style={{ width: "100%" }}>
        <Input
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={"#e2e8f0"}
          value={nome}
          styleBox={{ marginTop: 4 }}
          onChangeText={(text) => {
            setNome(text);
          }}
          width={"100%"}
          placeholder="Seu nome completo"
          bg={"#fff"}
          estiloNovo={{ rotulo: "Nome completo", corFoco }}
        />

        <Box style={{ flexDirection: "row", gap: 10, marginTop: 14 }}>
          <Box style={{ flex: 1 }}>
            <Input
              colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
              corBordaFiltro={"#e2e8f0"}
              mask="(99) 99999-9999"
              value={telefone}
              disabled={dadosImportados}
              onChangeText={(text) => {
                setTelefone(text);
              }}
              width={"100%"}
              placeholder="(00) 00000-0000"
              bg={"#fff"}
              estiloNovo={{ rotulo: "Telefone", corFoco }}
            />
          </Box>
          {/* <InputMask
            placeholder="(00) 00000-0000"
            icon="phone"
            width={"100%"}
            mask="(99) 99999-9999"
            value={telefone}
            onChangeText={setTelefone}
            colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
            corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
            helperText="Informe o seu telefone"
            styleBox={{ marginTop: 10 }}
            bg={"#fff"}
          /> */}
          <Box style={{ flex: 1 }}>
            <Input
              colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
              corBordaFiltro={"#e2e8f0"}
              mask="99/99/9999"
              value={dataNascimento}
              onChangeText={(text) => {
                setDataNascimento(text);
              }}
              width={"100%"}
              placeholder="DD/MM/AAAA"
              bg={"#fff"}
              estiloNovo={{ rotulo: "Nascimento", corFoco }}
            />
          </Box>
          {/* <InputMask
            colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
            corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
            value={dataNascimento}
            styleBox={{ marginTop: 10 }}
            icon={"calendar-today"}
            mask="99/99/9999"
            onChangeText={setDataNascimento}
            width={"100%"}
            placeholder="DD/MM/AAAA"
            helperText="Informe sua data de nascimento"
            bg={"#fff"}
          /> */}
        </Box>

        <Input
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={"#e2e8f0"}
          mask="999.999.999-99"
          value={cpf}
          styleBox={{ marginTop: 14 }}
          onChangeText={(text) => {
            setCpf(text);
          }}
          width={"100%"}
          placeholder="000.000.000-00"
          bg={"#fff"}
          estiloNovo={{ rotulo: "CPF", corFoco }}
        />
        {/* <InputMask
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
          width={"100%"}
          styleBox={{ marginTop: 10 }}
          placeholder="000.000.000-00"
          helperText="Informe o seu CPF"
          value={cpf}
          icon={"credit-card"}
          mask="999.999.999-99"
          onChangeText={setCpf}
          bg={"#fff"}
        /> */}
        <Input
          colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
          corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
          width={"100%"}
          styleBox={{ marginTop: 14 }}
          placeholder={"seuemail@exemplo.com"}
          value={email}
          disabled={dadosImportados}
          onFocus={() => {}}
          type="email"
          onChangeText={(text) => {
            setEmail(text);
          }}
          bg={"#fff"}
          estiloNovo={{ rotulo: "E-mail", corFoco }}
        />
      </Box>
    </>
  );
};

export default DadosBasicos;
